import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import {
  DataGrid,
  GridRowModes,
  GridActionsCellItem,
  GridRowEditStopReasons,
  useGridApiRef,
} from "@mui/x-data-grid";
import Toast from '../../components/Toast/Toast';
import ConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";
import Spinner from "../../components/Spinner/Spinner";
import {
  Typography,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import "./styles.css";
import { get, post } from "../../axiosUtils/appUtils";
import { config } from "../../lib/envConfig";
import { DELETE_USER_DETAILS_CONFIRMATION_MESSAGE, DELETE_USER_SUCCESS_MESSAGE, MODIFY_DETAILS_CONFIRMATION_MESSAGE, MODIFY_DETAILS_ERROR_MESSAGE, UPDATE_USER_SUCCESS_MESSAGE, USER_ACTIONS, USER_ROLES } from "../../lib/constant";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const UserAccessManagementDashboard = () => {

  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [open, setOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("success");
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [actionType, setActionType] = useState(USER_ACTIONS?.MODIFY); // 'modify' or 'delete'
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState({
    dialogTitle: "Warning!",
    dialogText: MODIFY_DETAILS_CONFIRMATION_MESSAGE,
    submitButtonText: " Save ",
  });
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const code = config?.VITE_FUNC_KEY_CODE;
  const apiRef = useGridApiRef();
  const { accounts } = useMsal();
  const userName = accounts.length > 0 ? accounts[0].username : "Guest";
  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem("userGroup")?.includes('Digital')) {
      navigate('/bulk-edit-fragrances');
    }
    fetchAllUsers();
    fetchAllCategories();
  }, []);

  // close confirmation dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    handleCancelClick(selectedRowId);
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  // on click of edit icon
  const handleEditClick = (id) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    setActionType(USER_ACTIONS?.MODIFY);
    setDialogData({
      dialogTitle: "Warning!",
      dialogText: MODIFY_DETAILS_CONFIRMATION_MESSAGE,
      submitButtonText: "Save",
    });
  };

  // on click of save icon
  const handleSaveClick = (id) => {
    setOpenDialog(true);
    setSelectedRowId(id);
  };

  // to fetch the list of all users
  const fetchAllUsers = () => {
    setLoading(true);
    const url = `/getAllUsers?code=${code}&libraryid=1&useremail=${userName}`;
    get(url)
      .then((response) => {
        const data = response?.data?.data.details;
        data.forEach((each, i) => {
          each.id = i + 1;
          each.Category = each?.Category ? each?.Category?.split(",") : [];
        });

        setRows(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setOpen(true);
        setToastMsg(MODIFY_DETAILS_ERROR_MESSAGE);
        setToastType("error");
        setOpenDialog(false);
      });
  };

  // to fetch the list of all categories
  const fetchAllCategories = () => {
   // setLoading(true);
    // replace url
    const url = `/getAllCategories?code=${code}&libraryid=1`;
    get(url)
      .then((response) => {
        setCategories(response?.data?.data || []);
       // setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setOpen(true);
        setToastMsg(MODIFY_DETAILS_ERROR_MESSAGE);
        setToastType("error");
        setOpenDialog(false);
      });
  };

  // api call to update or delete user details
  const saveData = (srNumber) => {
    const updateRowData = apiRef.current.getRowWithUpdatedValues(selectedRowId);

    let url = "";
    if (actionType === USER_ACTIONS?.DELETE) {
      url = `/updateUserCategory?code=${code}&user_email=${updateRowData?.UserEmailId}&category=""&Role=""&srNumber=${srNumber}`;
    } else {
      url = `/updateUserCategory?code=${code}&user_email=${updateRowData?.UserEmailId}&category=${updateRowData?.Category}&Role=${updateRowData?.UserRole}&srNumber=${srNumber}`;
    }

    post(url)
      .then((response) => {
        setRowModesModel({
          ...rowModesModel,
          [selectedRowId]: { mode: GridRowModes.View },
        });

        setOpen(true);
        setToastMsg(
          actionType === USER_ACTIONS?.DELETE
            ? DELETE_USER_SUCCESS_MESSAGE
            : UPDATE_USER_SUCCESS_MESSAGE
        );
        setToastType("success");
        setSelectedRowId(null);
        setOpenDialog(false);
        fetchAllUsers();
      })
      .catch((error) => {
        setOpen(true);
        setToastMsg(MODIFY_DETAILS_ERROR_MESSAGE);
        setToastType("error");
        setOpenDialog(false);
      });
  };


  // on click of delete icon
  const handleDeleteClick = (id) => {
    setOpenDialog(true);
    setSelectedRowId(id);
    setActionType(USER_ACTIONS?.DELETE);

    setDialogData({
      dialogTitle: "Warning!",
      dialogText: DELETE_USER_DETAILS_CONFIRMATION_MESSAGE,
      submitButtonText: "Delete",
    });
  };

  // on click of cancel icon
  const handleCancelClick = (id) => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  // close toast
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const columns = [
    {
      field: "UserEmailId",
      headerName: "Email",
      align: "left",
      headerAlign: "left",
      editable: false,
      headerClassName: "custom-header",
      flex: 1 
    },
    {
      field: "UserRole",
      headerName: "Role",
      editable: true,
      type: "singleSelect",
      valueOptions: USER_ROLES,
      headerClassName: "custom-header",
      flex: 1
    },
    {
      field: "Category",
      headerName: "Category",
      editable: true,
      flex: 1,
      renderEditCell: (params) => {
        const handleChange = (event) => {
          const value = event.target.value;
          params.api.setEditCellValue({
            id: params.id,
            field: "Category",
            value,
          });
        };

        return (
          <Select
            sx={{ width: "100%" }}
            multiple
            value={params.value}
            onChange={handleChange}
            renderValue={(selected) => selected.join(", ")}
          >
            {categories.map((option, index) => (
              <MenuItem
                key={`${option?.Category}-${index}`}
                value={option?.Category}
              >
                <Checkbox checked={params.value?.includes(option?.Category)} />
                <ListItemText primary={option?.Category} />
              </MenuItem>
            ))}
          </Select>
        );
      },
      headerClassName: "custom-header",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      editable: false,
      cellClassName: "actions",
      headerClassName: "custom-header",
      flex: 1,
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={
                <SaveIcon
                  style={{
                    border: "1px solid blue",
                    borderRadius: "4px",
                    padding: "0.5rem 1rem",
                  }}
                />
              }
              title="Save"
              sx={{ color: "blue" }}
              onClick={() => handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={
                <CancelIcon
                  style={{
                    border: "1px solid crimson",
                    color: "crimson",
                    borderRadius: "4px",
                    padding: "0.5rem 1rem",
                  }}
                />
              }
              title="Cancel"
              onClick={() => handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={
              <EditIcon
                style={{
                  border: "1px solid blue",
                  borderRadius: "4px",
                  padding: "0.5rem 1rem",
                  color: "blue",
                }}
              />
            }
            title="Edit"
            onClick={() => handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={
              <DeleteIcon
                style={{
                  border: "1px solid crimson",
                  color: "crimson",
                  borderRadius: "4px",
                  padding: "0.5rem 1rem",
                }}
              />
            }
            title="Delete"
            onClick={() => handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <>
      <Box
        sx={{
          height: 500,
          width: "100%",
          marginBottom: '1.5rem',
          "& .actions": {
            color: "text.secondary",
          },
          "& .textPrimary": {
            color: "text.primary",
          },
        }}
      >

        <Typography color="inherit" variant="body1" style={{  marginBottom: '1rem' }}>
            *Note: User additions to Active Directory (AD) groups and role changes must be managed through {" "}
            <a href="https://portal.azure.com/">Azure portal</a>
        </Typography>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, fontWeight: "bold", marginBottom: 2 }}
        >
          Users List
        </Typography>

        {loading ? (
          <Spinner />
        ) : (
          <>
            <DataGrid
              apiRef={apiRef}
              rows={rows}
              columns={columns}
              editMode="row"
              rowModesModel={rowModesModel}
              onRowModesModelChange={handleRowModesModelChange}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={processRowUpdate}
              isRowSelectable={() => false}
              showToolbar
              disableColumnSelector
              sx={{
                height: "max-content",
                ".MuiSvgIcon-root": {
                  color: "blue",
                },
              }}
              pageSizeOptions={[5, 10, 25]}
              slotProps={{
                toolbar: {
                  setRows,
                  setRowModesModel,
                  printOptions: { disableToolbarButton: true },
                },
              }}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 10, page: 0 },
                },
              }}
            />           
          </>
        )}
        <Toast
          toastMsg={toastMsg}
          open={open}
          handleClose={handleClose}
          severity={toastType}
        />
        <ConfirmationDialog
          open={openDialog}
          handleClose={handleCloseDialog}
          saveData={saveData}
          dialogData={dialogData}
          isSRNumberRequired={true}
        />
      </Box>
    </>
  );
};

export default UserAccessManagementDashboard;